import { Outlet } from "react-router-dom";
import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import Navbar from "../../../../components/navbar/navbar";
import Footer from "../../../../components/footer/Footer";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";

function NationalsMain() {
  const [tSMetaData] = useTranslation("metaData");
  return (
    <div>
      <Helmet>
        <title>{tSMetaData("nacionales.title")}</title>
        <meta
          name="description"
          content={tSMetaData("nacionales.description")}
        />
      </Helmet>
      <ScrollToTop />
      <Navbar />
      <Outlet />
      <Footer />
    </div>
  );
}

export default NationalsMain;
